module.exports = __webpack_public_path__ + "images/lab/repositories-9586fc4ba62e54d0c861a54c87513ea0.jpg";